import RestClient from "./RestClient";

const ShowInfoAPI = {};

ShowInfoAPI.install = (Vue) => {
  const vue = Vue;
  vue.prototype.$ShowInfoAPI = {
    QueryShowInfo(data) {
      return RestClient.post(`/query-real-time-show-summary`,data);
    },
  };
};

export default ShowInfoAPI;
